<template>
  <top-bar v-if="$store.state.isAuth == true"></top-bar>
  <router-view />
</template>
<script>
import TopBar from "@/components/TopBar.vue";
export default {
  name: "HomeView",
  components: {
    TopBar,
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.tocenter {
  text-align: center;
}
</style>
